@switch (data?.content?.contents?.type) {
  @case ('bubble') {
    <flex-bubble
      [data]="data.content.contents"
      [bubble]="data.content.contents"
      [flex]="data"
      [style.pointerEvents]="canSelect ? 'auto' : 'none'"
      class="flexSolo"
      [attr.data-testid]="'preview-bubble'"
    >
    </flex-bubble>
  }
  @case ('carousel') {
    <flex-carousel
      [data]="data.content.contents"
      [flex]="data"
      [attr.data-testid]="'preview-carousel'"
    >
    </flex-carousel>
  }
}
